import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getVideoById } from "@store/action/multimedia/VideoAction";
import { useTranslation } from "react-i18next";
import { Mail } from "react-feather";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  FacebookMessengerShareButton,
  EmailShareButton,
  FacebookMessengerIcon,
  WhatsappIcon,
} from "react-share";
import BreadCrumbs from "@components/breadcrumbs/index1";
import Filter from "../Filter";
import Comment from "./Comment";

const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

const VideoId = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const store = useSelector((state) => state.VideoReducer);
  const id = useParams().id;
  const datas = store.single;
  const shareUrl = window.location.href;
  useEffect(() => {
    dispatch(getVideoById(id));
  }, [dispatch, id]);

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={`Video ${t("Details")}`} />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter
              t={t}
              store={store}
              dispatch={dispatch}
              setCurrentPage={() => {}}
            />
            <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 blog_responsive">
              <div className="blog_category_box_wrapper blog_box_wrapper float_left">
                <div className="blog_news_img_wrapper float_left">
                  <video
                    width="100%"
                    height="450px"
                    controls
                    src={datas && datas.file_path}
                  />
                </div>
                <div className="lest_news_cont_wrapper float_left">
                  <div className="blog_heaidng_top">
                    <span>
                      <i className="flaticon-calendar" />
                      {new Date(datas?.created_at).toLocaleString({
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                    <h3>
                      <a>{datas?.video_info?.title}</a>
                    </h3>
                  </div>
                  <div className="blog-single_cntnt">
                    <p>{datas?.video_info?.length_text}</p>{" "}
                    <p>{datas?.video_info?.description}</p>
                    <ul className="icon_list_news  detail_icon_lists">
                      <FacebookShareButton url={shareUrl}>
                        <li>
                          <a className="fb">
                            <i className="fab fa-facebook-f" />
                            <br /> Facebook
                          </a>
                        </li>
                      </FacebookShareButton>
                      <TwitterShareButton url={shareUrl}>
                        <li>
                          <a className="twit">
                            <i className="fab fa-twitter" />
                            <br /> twitter
                          </a>
                        </li>
                      </TwitterShareButton>
                      <WhatsappShareButton url={shareUrl}>
                        <li>
                          <a className="share">
                            <WhatsappIcon size={34} round={true} />
                            <br /> Whatsapp
                          </a>
                        </li>
                      </WhatsappShareButton>
                      <FacebookMessengerShareButton url={shareUrl}>
                        <li>
                          <a className="linkd">
                            <FacebookMessengerIcon size={34} round={true} />
                            <br /> Messenger
                          </a>
                        </li>
                      </FacebookMessengerShareButton>
                      <EmailShareButton url={shareUrl}>
                        <li>
                          <a className="vimo">
                            <Mail />
                            <br /> E-mail
                          </a>
                        </li>
                      </EmailShareButton>
                    </ul>
                  </div>
                </div>
              </div>

              <Comment t={t} dispatch={dispatch} VideoReducer={store} id={id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoId;
